import Vue from 'vue'
import VueFeather from '@/assets/vendor/vue-feather/src'

Vue.use(VueFeather)
